<template>
	<div class="col-sm-12">
		<br />
		<!-- <pre>{{dIn}}</pre> -->
		<div v-for="(cnt, id) in data" class="well well-sm">
			<div class="row">
				<div class="col-sm-4">
					<input
						:disabled="disabled"
						type="text"
						class="form-control"
						placeholder="Nome"
						title="Nome"
						v-model="cnt.name"
					/>
				</div>
				<div class="col-sm-4">
					<input
						:disabled="disabled"
						type="text"
						class="form-control"
						placeholder="Email"
						title="Email"
						v-model="cnt.mail"
					/>
				</div>
				<div class="col-sm-3">
					<input
						:disabled="disabled"
						type="text"
						class="form-control"
						placeholder="Telefones"
						title="Telefones"
						v-model="cnt.tels"
					/>
				</div>
				<div class="col-sm-1">
					<button
						v-if="!disabled"
						@click="$emit('remove', id)"
						class="btn btn-danger btn-block"
					>
						<i class="fa fa-trash"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['dIn', 'disabled'],
		computed: {
			data() {
				return this.dIn.contatos;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/customers/components/contacts.vue